<template>
    <div v-show="isActive" v-if="isInitialized">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true
            },
            id: {
                type: String,
                required: true
            }
        },
        watch: {
            isActive(value) {
                if (value) {
                    this.isInitialized = true;
                }
            }
        },
        data() {
            return {
                isActive: false,
                isInitialized: false
            };
        },
        computed: {
            href() {
                return '#' + this.id.toLowerCase().replace(/ /g, '-');
            }
        },
    }
</script>
